import { Action } from "@/app/constants/enums";
import { useUser } from "@/app/context/UserContext";
import { getcurrentUser } from "@/app/helpers/functions";
import { iActionRequest } from "@/app/models/interfaceChatBotAction";
import { chatbotSaveAction } from "@/app/services/chatbotsaveaction";
import { forwardRef } from "react";

interface ButtonChatProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  actionCode: string;
}

const ButtonChat = forwardRef<HTMLButtonElement, ButtonChatProps>(
  ({ actionCode, children, ...props }, ref) => {
    const { user, userProject,accessType } = useUser();

    const sendFormData = (form: HTMLFormElement | null, props:any) => {
      if (!user?.email) return;
      
      const data: Record<string, any> = {};
     
      if ((props.type === "submit" || props.type === "reset") && form) {
        const formData = new FormData(form); 
        formData.forEach((value, key) => {
          data[key] = value;
        });
      } else if(props.type==="button"){
        data["click"] = props.onClick; 
      } 
      
      const formObject: Record<string, any> = {
        target: "button",
        type: props.type,
        data,
      }; 
      const request: iActionRequest = {
        company_code: userProject?.project?.company_code ?? "",
        project_id: userProject?.project?.id ?? "",
        //user_id: user.email,
        user_id: getcurrentUser(accessType, userProject, user),
        action_code: actionCode,
        action_detail: formObject,
      }; 
      if(Action.LEFT_FORM_ENVIO != actionCode )
        chatbotSaveAction(request).catch((error) => {
          console.error("Error al guardar en acción:", error);
        });
    };
    

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => { 
      props.onClick?.(e);
      const form = e.currentTarget.form;      
      sendFormData(form, props);
      
    };

    return (
      <button {...props} ref={ref} onClick={handleClick}>
        {children}
      </button>
    );
  }
);

ButtonChat.displayName = "ButtonChat";
export default ButtonChat;
